
import React from "react";
import moment from "moment";


export const vendorDetailsLabelFieldMapping = () => {
    return [
        { label: 'Vendor Type', field: 'vendorType' },
        {
            label: 'PAN Card Number',
            field: 'panNumber',
            renderExtra: (value) => (
                <span
                    style={{
                        color: 'var(--Aqua-500, #00B0F5)',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '20px'
                    }}
                >
                    {value}
                </span>
            )
        },
        { label: 'Vendor Name', field: 'fullName' },
        { label: 'Payment order ID', field: 'paymentOrderId' },
        { label: 'Vendor ID', field: 'vendorSapCode' },
        { label: 'Approval Status', field: 'approvalStatus' },
        { label: 'SAP Status', field: 'SAP Status' },
        { label: 'SAP Document No.', field: 'sapDocumentNumber' },
        { label: 'SAP Date', field: 'sapDate' },
    ]
}

export const getPaymentMappingPayload = (values = {}, stream = {}) => {
    const vendorDetails = values?.vendorDetails || {};
    const addVendorForm = values?.addVendorForm || {};
    const vendorType = values?.vendorType;

    const vendorId = vendorDetails?.id || "";
    const businessAreaId = addVendorForm?.businessArea?.value || "";
    const academicYearId = addVendorForm?.year?.value || "";
    const academicGroupId = stream?.value ? Number(stream.value) : "";
    const sapPlantId = addVendorForm?.businessArea?.sapPlantId || "";

    return {
        vendorId,
        businessAreaId,
        academicYearId,
        academicGroupId,
        ...(vendorType?.toUpperCase() === 'INVIGILATOR' ? { sapPlantId } : {}),
    };
};


export const createVendorRequestPayload = (values = {}) => {
    const vendorId = values?.vendorDetails?.id;
    const vendorType = values?.vendorType;
    const { businessArea, year } = values?.addVendorForm
    const isInvigilator = vendorType?.toUpperCase() === 'INVIGILATOR';

    if (!vendorId) return null;

    const streams = ["SOE", "SOM", "SOF"];

    const vendorPsidMappingList = streams
        .filter((key) => values?.[key]?.hasData && Array.isArray(values?.[key]?.list))
        .flatMap((key) =>
            values[key].list.map((row) => ({
                vendorPsidMappingId: row?.id ?? null,
                amount: row?.amount ?? 0,
                psid: (!isInvigilator ? row?.psid : row?.timeTableId) ?? "",
                academicGroupId: !isInvigilator ? row?.academicGroup : row?.academicGroupId,
                academicGroupDispValue: row?.academicGroupDispValue ?? key,
                term: row?.term ?? "",
                termDispVal: row?.termDispVal ?? "",
                termId: row?.termId ?? "",
                costCenter: row?.costCenter
            }))
        );

    return {
        vendorId,
        vendorType,
        businessAreaId: businessArea?.value,
        businessAreaDispValue: businessArea?.label,
        academicYearId: year?.value,
        academicYearDispValue: year?.label,
        vendorPsidMappingList
    };
};

export const maskBankAccountNumber = (accNumber = "") => {
    if (!accNumber) return "-";

    if (accNumber.length <= 4) return accNumber;

    const lastFour = accNumber.slice(-4);
    const masked = "X".repeat(accNumber.length - 4);

    // Add space after every 4 characters
    const formattedMasked = masked.match(/.{1,4}/g)?.join(" ") || masked;

    return `${formattedMasked} ${lastFour}`;
};

export const getDuration = (start, end) => {
    if (!start || !end) return "-";

    const duration = moment.duration(moment(end).diff(moment(start)));

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    if (hours === 0) return `${minutes}m`;
    if (minutes === 0) return `${hours}h`;

    return `${hours}h ${minutes}m`;
};


export const SEARCH_BY = [
    {
        key: "name",
        value: "By Name",
    },
    {
        key: "vendor",
        value: "Vendor ID",
    },
];